<template>
  <OmtLayoutContainer>
    <OmtRow v-if="isOtherMatters" mb="12px">
      <OmtTypography as="h1-regular"> <omt-bold>Outros assuntos</omt-bold> (Obrigatório) </OmtTypography>
    </OmtRow>
    <OmtRow v-else mb="12px">
      <OmtTypography as="h1-regular"> <omt-bold>Observações</omt-bold> (Opcional)</OmtTypography>
    </OmtRow>
    <OmtRow mb="12px">
      <OmtTypography as="p1" color="#4E4E4E" font-weight="400 !important" v-if="isOtherMatters">
        <omt-bold :light="true" color="#4E4E4E">
          Descreva aqui a sua dúvida ou a informação que você precisa:
        </omt-bold>
      </OmtTypography>
      <OmtTypography as="p1" color="#4E4E4E" font-weight="400 !important" v-else>
        <omt-bold :light="true" color="#4E4E4E"> Todas as suas informações necessárias foram preenchidas. </omt-bold>
        Para finalizar, você gostaria de incluir alguma observação?
      </OmtTypography>
    </OmtRow>
    <OmtRow>
      <CFlex flexDirection="column" alignItems="flex-end">
        <OmtTextarea
          class="input-observation"
          height="109px"
          padding="12px"
          :placeholder="'Inclua informações ou detalhes que podem complementar os documentos enviados.'"
          @change="handleChange"
          @focus.native="onInputFocus"
          :initialValue="observation"
          maxlength="500"
        />
        <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> {{ observation.length }}/500 </OmtTypography>
      </CFlex>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton
        :w="['100%', '308px !important']"
        @click="submit"
        :is-disabled="isOtherMatters && observation.trim().length < 1"
      >
        {{ !isOtherMatters ? "Enviar" : "Continuar" }}
      </OmtButton>
    </OmtRow>
    <SentRequestModal
      :isOutros="isOtherMatters"
      :isOpen="modalSuccess"
      :daysAnalizy="daysAnalizy"
      :protocol="protocolANS"
      @close="closeModal"
      @save="saveEvaluation"
    />
  </OmtLayoutContainer>
</template>

<script>
import SentRequestModal from "@/components/Organisms/Requests/SentRequestModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "ObservationRequest",
  components: {
    SentRequestModal
  },
  data() {
    return {
      daysAnalizy: 2,
      modalSuccess: false,
      observation: "",
      protocolANS: ""
    };
  },
  computed: {
    ...mapState("request", ["addPermission", "newRequest", "subjectOptions"]),
    isOtherMatters() {
      return this.subjectOptions.find(s => s.value === this.newRequest.subject)?.outros || false;
    }
  },
  methods: {
    ...mapActions("request", ["createRequestTicket", "fetchProtocols"]),
    ...mapActions("ticket", ["saveExpRating"]),
    ...mapMutations("request", ["RESET_NEW_REQUEST", "SET_OBSERVATION", "SET_NEW_REQUEST_SUCCESS"]),
    handleChange(text) {
      this.observation = text;
      this.SET_OBSERVATION(text);
    },
    async submit() {
      if (this.isOtherMatters) {
        this.$router.push({
          name: "request.upload.documents"
        });
        return;
      }

      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.createRequestTicket({ obs: this.observation });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (response && response.Data) {
        this.daysAnalizy = response.Data.prazos;
        this.protocolANS = response.Data.protocoloANS;
        this.modalSuccess = true;
        this.SET_NEW_REQUEST_SUCCESS(true);
        this.RESET_NEW_REQUEST();
        this.fetchProtocols({ protocol: this.protocolANS });
      } else {
        await this.$toast({
          description: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    },
    closeModal() {
      this.$router.push("/solicitacoes");
    },
    async saveEvaluation({ rating, obs }) {
      await this.$root.$emit("show-loading");
      try {
        await this.saveExpRating({
          ticket: this.protocolANS,
          type: "9",
          step: "S",
          rating,
          obs
        });
      } finally {
        this.$router.push("/solicitacoes");
      }
    },
    onInputFocus(event) {
      setTimeout(() => {
        if ((window.visualViewport?.height ?? window.innerHeight) < 390) {
          const rect = event.target.getBoundingClientRect();
          window.scrollTo({ top: window.scrollY + rect.top - 90, behavior: "smooth" });
        }
      }, 400); // Timeout para o tempo que o teclado virtual leva para abrir
    }
  },

  mounted() {
    if (!this.addPermission) {
      this.$router.replace("/solicitacoes");
      return;
    }
    if (!this.newRequest?.subject) {
      this.$router.replace("/solicitacoes/criar");
      return;
    }

    const subject = this.subjectOptions.find(s => s.value === this.newRequest.subject);

    if (!subject?.daysAnalizy) {
      this.$router.replace("/solicitacoes/criar");
      return;
    }
    this.daysAnalizy = subject.daysAnalizy;
    this.observation = this.newRequest.observation || "";

    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
::v-deep .input-observation {
  border: 0.5px solid #dadada;
  color: #8c8c8c !important;
}

::v-deep .input-observation::placeholder {
  color: #8c8c8c !important;
}
</style>
